import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Agent } from '../../../domain/agents/models/Agent';
import { mapProGPTAgentToMetadata } from '../../../services/providers/progpt/mappers/mapProGPTAgentToMetadata';
import { AgentsState, initialAgentsState } from './agentsState';

const agentsSlice = createSlice({
    name: 'agents',
    initialState: initialAgentsState,
    reducers: {
        setAgents: (state: AgentsState, action: PayloadAction<Agent[]>) => {
            state.byId = {};
            state.allIds = [];

            for (const agent of action.payload) {
                state.byId[agent.agentId] = agent;
                state.allIds.push(agent.agentId);
            }

            // ensure that the hardcoded progpt agent is always present in the list of agents
            const defaultProGPTAgent = mapProGPTAgentToMetadata();

            if (!state.byId[defaultProGPTAgent.agentId]) {
                state.byId[defaultProGPTAgent.agentId] = defaultProGPTAgent;
                state.allIds.push(defaultProGPTAgent.agentId);
            }
        },
        updateAgent: (state: AgentsState, action: PayloadAction<Agent>) => {
            const agent = action.payload;
            state.byId[agent.agentId] = agent;
            if (!state.allIds.includes(agent.agentId)) {
                state.allIds.push(agent.agentId);
            }
        },
        clearAgents: (state: AgentsState) => {
            state.byId = {};
            state.allIds = [];
        },
    },
});

export const { setAgents, updateAgent, clearAgents } = agentsSlice.actions;

export default agentsSlice.reducer;
